import { useEffect, useRef, useState } from "react"
import { TextBtn } from "../../../shared";
import { ReactComponent as LogoNew } from '../../../assets/images/icon/logo.svg'
import { deepLinkBridgeElseNewTab } from "../../../utils";
import { useNavigate } from "react-router-dom";

interface IProps {
    isOpen: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const AppDownBottomSheet = ({ isOpen, setIsOpen }: IProps) => {
    const [isDisplayNone, setIsDisplayNone] = useState(true);
    const [isVisible, setIsVisible] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const bottomValue = isVisible ? 0 : `-${(contentRef.current?.offsetHeight || 402) + 10}px`;
    const appDownLocalStorageKey = 'appDownNotViewedUntil';
    const handleTransitionEnd = () => {
        if (!isOpen) {
            setIsDisplayNone(true);
        }
    };

    const getToday = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today.getTime();
    };

    const handleNotVeiwClick = (day: number) => {
        const today = getToday();
        const tomorrow = today + day * 24 * 60 * 60 * 1000;
        localStorage.setItem(appDownLocalStorageKey, tomorrow.toString());
    };

    useEffect(() => {
        if (isOpen) {
            const today = getToday();
            const checkValue = localStorage.getItem(appDownLocalStorageKey);
            const storedNotViewedUntil = parseInt(checkValue ?? '0', 10);
            if (!storedNotViewedUntil || today >= storedNotViewedUntil) {
                setIsDisplayNone(false);
                requestAnimationFrame(() => {
                    setIsVisible(true);
                });
                document.body.classList.add('overflow-hidden');
            }
        } else {
            setIsVisible(false);
            document.body.classList.remove('overflow-hidden')
        }
    }, [isOpen]);

    return <>
        <div className="custom-bottom-sheet-mask" onClick={() => { setIsOpen(false) }} style={{ display: isDisplayNone ? 'none' : 'block', marginInline: 'auto', position: 'fixed', top: 0, zIndex: 3, width: '100vw', maxWidth: '480px', height: '100dvh', backgroundColor: 'var(--dim-d200, #000000B2)', pointerEvents: 'auto' }}>
            <div ref={contentRef} className="custom-bottom-sheet-content" onClick={e => e.stopPropagation()} onTransitionEnd={handleTransitionEnd} style={{ position: 'absolute', bottom: bottomValue, transition: 'bottom 0.5s ease' }} >
                <div className="custom-bottom-sheet-body" style={{ width: '100vw', maxWidth: '480px', borderRadius: 'var(--radius16) var(--radius16) 0 0', backgroundColor: 'var(--basewhite)' }}>
                    <div style={{ padding: '32px 20px', textAlign: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '72px', height: '72px', marginInline: 'auto', marginBottom: '20px', boxShadow: '0px 4px 16px 0px #0000001A', borderRadius: 'var(--radius8)' }} >
                            <LogoNew width={'57.6px'} />
                        </div>
                        <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                            <div className="sub-title/st4 base/black">
                                파지티브호텔 앱에서<br />
                                더 많은 프로그램을 만나보세요
                            </div>
                            <div className="body/b2 secondary/s800">
                                리트리트부터 원데이 클래스까지!<br />
                                다양한 웰니스 프로그램이 기다리고있어요.
                            </div>
                        </div>
                        <div className="sub-title/st3 base/white" onClick={() => { window.open('https://positivehotel.page.link/sBAV') }}
                            style={{ paddingBlock: '12px', marginBottom: '20px', textAlign: 'center', borderRadius: 'var(--radius4)', backgroundColor: 'var(--baseblack)' }}>
                            앱으로 살펴보기
                        </div>
                        <TextBtn children='웹으로 계속 둘러보기' type='underline' icon={false} onClick={() => { handleNotVeiwClick(3); setIsOpen(false) }} />
                    </div>
                </div>
            </div>
        </div>
    </>
}

export default AppDownBottomSheet
